import { useState } from "react";
import { useListsContext } from "../ListsContext";
import { SmallButton } from "../Lists.styled";
import { ListNameModal } from "./ListNameModal";

// Owns its own modal state so it can sit both in the list panel header and in the
// empty state, where there is no panel yet.
export function NewListButton() {
  const { createList } = useListsContext();
  const [open, setOpen] = useState(false);

  return (
    <>
      <SmallButton type="button" onClick={() => setOpen(true)}>
        + New List
      </SmallButton>
      {open && (
        <ListNameModal
          heading="New List"
          submitLabel="Create"
          onSubmit={createList}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
